import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { FIVE_MINUTES } from '~/constants'
import { INewbornScreeningTest, IGetNewbornScreeningParams } from '~/interfaces'
import { fetchNewbornScreening } from '~/services'

const UNIQUE_KEY = 'newbornScreening'

export const useFetchNewbornScreening = (
  fetchParams: IGetNewbornScreeningParams
): UseQueryResult<INewbornScreeningTest[], Error> => {
  //
  const fetcher = async (): Promise<INewbornScreeningTest[]> => {
    try {
      const response = await fetchNewbornScreening(fetchParams)
      const isResponseEmpty = response.length === 0

      if (isResponseEmpty) {
        throw ReferenceError('Não há dados de triagem neonatal para este paciente.')
      }

      return response
    } catch (error) {
      if (error instanceof ReferenceError) throw new Error(error.message)
      throw new Error('Não há dados de triagem neonatal disponíveis no momento.')
    }
  }

  return useQuery([UNIQUE_KEY, fetchParams], fetcher, {
    enabled: fetchParams?.patientId !== null,
    cacheTime: FIVE_MINUTES
  })
}
